import { EnumFeedCardCategoryVariant } from "src/components/feed-card/types/enums";

export const getVariant = (initialVariant: EnumFeedCardCategoryVariant) => {
    switch (initialVariant) {
        case EnumFeedCardCategoryVariant.Full:
            return "solid";
        case EnumFeedCardCategoryVariant.Outlined:
            return "outline";
        default:
            // TS protection of missing case
            const unknownVariant: never = initialVariant;
            return unknownVariant;
    }
};
